import "./infoSelectPanel.css";

import { OverlayPanel } from "primereact/overlaypanel";
import React, { useRef } from "react";

import { ContainerScrollCommon } from "../../../common/components/TableResponsive";
import icArrowDown from "../../../images/ic_arrow_down.svg";
import {
  ButtonOverlList,
  DivFirstValue,
  ItemInfoPanel,
} from "../AdminPaymentValidationStatesSidebarStyles";

export const InfoSelectPlanel = (props) => {
  const {
    width,
    height,
    widthPanel,
    heightPanel,
    items,
    fontSizeCounLabel,
    iconCountWith,
    iconCountHeight,
    bankType,
  } = props;
  const menu = useRef(null);
  return (
    <React.Fragment>
      {(items || []).length > 1 ? (
        <ButtonOverlList
          width={width}
          height={height}
          fontSizeCounLabel={fontSizeCounLabel}
          iconCountWith={iconCountWith}
          iconCountHeight={iconCountHeight}
          marginRight="0.3rem"
        >
          <DivFirstValue
            fontWeight={bankType ? 600 : 500}
            color={bankType ? "#002e6c" : "#08082B"}
            fontSize={bankType ? "1.5rem" : "2.4rem"}
            width={bankType ? "9rem" : "auto"}
          >
            {items[0]}
          </DivFirstValue>
          <div
            className="conent-icons"
            onClick={(event) => menu.current.toggle(event, event.target)}
            style={{ cursor: "pointer" }}
          >
            <div className="icon-count">
              <h1>+{(items || []).length - 1}</h1>
            </div>
            <img src={icArrowDown} alt="" />
          </div>
        </ButtonOverlList>
      ) : (
        <ButtonOverlList
          width={width}
          height={height}
          fontSizeCounLabel={fontSizeCounLabel}
        >
          <DivFirstValue
            fontWeight={bankType ? 600 : 500}
            color={bankType ? "#002e6c" : "#08082B"}
            fontSize={bankType ? "1.5rem" : "2.4rem"}
            width={bankType ? "9rem" : "auto"}
          >
            {items[0]}
          </DivFirstValue>
        </ButtonOverlList>
      )}

      <OverlayPanel
        className="overly-styles"
        style={{
          maxWidth: "230.1rem",
          width: widthPanel ? widthPanel : "auto",
          height: heightPanel ? heightPanel : "auto",
          borderRadius: 8,
          boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.1)",
        }}
        ref={menu}
      >
        <ContainerScrollCommon
          height={
            items.length === 1
              ? "5rem"
              : items.length === 2
              ? "10rem"
              : items.length === 3
              ? "15rem"
              : items.length > 5
              ? "25rem"
              : "auto"
          }
        >
          <div
            style={{ overflowY: "scroll", maxHeight: "60vh" }}
            className="scroll"
          >
            {(items || []).map((test, i) => {
              return (
                <ItemInfoPanel key={i}>
                  {bankType ? (
                    <h1 style={{ color: "#002E6C", fontWeight: 600 }}>
                      {test.toUpperCase()}
                    </h1>
                  ) : (
                    <h1>{test}</h1>
                  )}
                </ItemInfoPanel>
              );
            })}
          </div>
        </ContainerScrollCommon>
      </OverlayPanel>
    </React.Fragment>
  );
};
